import React from "react";
import HeroImg from "./assets/images/hero-1.png";
import Shield from "./assets/icons/shield (2).png";
import Armour from "./assets/icons/armour.png";
import Filter from "./assets/icons/filter (2).png";
import Pipette from "./assets/icons/pipette.png";
// import Consult from "./components/Consult";
// import Testimonials from "./components/Testimonials";
// import Location from "./assets/icons/location.png";
// import Phone from "./assets/icons/phone2.png";
// import Gmail from "./assets/icons/gmail2.png";
// import AboutImg1 from "./assets/images/about1.png";
// import AboutImg2 from "./assets/images/about2.png";
import Nurse from "./assets/images/nurse.png";
import Nurses from "./assets/images/nurses.png";
import Award from "./assets/images/award.png";
import Doctor from "./assets/images/doctor.png";
import Whatsapp from "./assets/icons/whatsapp.png";
import { useNavigate } from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css"; // You can also use <link> for styles

import { FaLocationDot } from "react-icons/fa6";
import { FaPhone } from "react-icons/fa";
import { MdEmail } from "react-icons/md";
// ..
AOS.init();

const Home = () => {
  const services = [
    {
      id: 1,
      service: "Blood Analysis",
      prop1: "Packed Cell Volume (PCV)",
      prop2: "Full Blood Count (FBC)",
      prop3: "Peripheral Blood Film (PBF) + FBC",
      prop4: "Erythrocyte Sedimentation Rate (ESR)",
    },
    {
      id: 2,
      service: "Blood Typing & Screening",
      prop1: "Hemoglobin Genotype",
      prop2: "Blood Group",
      //   prop3: "Peripheral Blood Film (PBF) + FBC",
      //   prop4: "Erythrocyte Sedimentation Rate (ESR)",
    },
    {
      id: 3,
      service: "Infection Screening",
      prop1: "Malaria (Blood Film)",
      prop2: "Widal Test",
      prop3: "Malaria/Widal Test",
      prop4: "Erythrocyte Sedimentation Rate (ESR)",
    },
    {
      id: 4,
      service: "Viral Screening",
      prop1: "Hepatitis B Screening",
      prop2: "Hepatitis C Screening",
      prop3: "HIV Screening",
      prop4: "HBV Panel",
    },
    {
      id: 5,
      service: "Organ Function Tests",
      prop1: "E/U/CR",
      prop2: "Liver Function Test (Maxi Panel)",
      //   prop3: "HIV Screening",
      //   prop4: "HBV Panel",
    },
  ];

  const navigate = useNavigate();
  return (
    <div>
      {/* hero-section */}
      <section
        style={{ backgroundImage: `url(${HeroImg})` }}
        className="w-full h-[60vh] md:h-[70vh] lg:h-[100vh] relative  flex items-start justify-center flex-col gap-3 bg-center bg-cover"
      >
        <div className="bg-gradient-to-r md:h-[70vh] lg:h-[100vh] from-[#1C022180]/100 to-[#1C022180]/50 h-[60vh] w-full absolute top-0"></div>
        <div
          data-aos="fade-in"
          data-aos-delay="0"
          data-aos-duration="1000"
          className="z-10 lg:px-24 md:px-10 px-4 "
        >
          <div className="lg:w-[75%] md:w-[85%] text-white flex flex-col gap-4">
            <h1 className="md:text-5xl text-3xl text-white font-semibold md:leading-[3.5rem]">
              Advanced Medical Diagnostics for Your Health
            </h1>
            <p className="md:text-lg text-base lg:text-base md:w-[70%] lg:w-full">
              Accurate Results, Professional Care, Quick Turnaround
            </p>
          </div>
          <button
            onClick={() => navigate("/book-appointment")}
            className="font-semibold mt-8 rounded-full py-3 lg:px-7 px-6 md:px-5 bg-white text-primaryPurple md:text-[0.75rem] lg:text-base"
          >
            Book Your Test Now
          </button>
        </div>
      </section>

      <section className="lg:px-24 md:px-10 px-4 py-10 flex flex-col md:flex-row items-center gap-10 justify-between">
        <div className="md:w-[50%] lg:w-[60%]">
          <h1 className="text-primaryPurple md:text-2xl lg:text-3xl text-3xl font-bold">
            About Clear-Icon-Medical
          </h1>
          <p
            data-aos="fade-up"
            data-aos-delay="0"
            data-aos-duration="1000"
            className="text-gray-600 py-3 text-sm leading-[1.6rem]"
          >
            With over 15 years of experience in medical diagnostics, Clear-Icon
            Medical is committed to providing accurate, reliable, and timely
            diagnostic services to our patients. Our state-of-the-art laboratory
            facilities and experienced team ensure the highest quality of care.
          </p>

          <div
            data-aos="fade-up"
            data-aos-delay="0"
            data-aos-duration="1000"
            className="grid-flow-row text-sm grid text-gray-600 grid-cols-2 gap-5"
          >
            <div className="flex items-center gap-2">
              <img src={Shield} alt="" />
              <p>State-of-the-art Equipment</p>
            </div>
            <div className="flex items-center gap-2">
              <img src={Filter} alt="" />
              <p>Expert Technicians</p>
            </div>
            <div className="flex items-center gap-2">
              <img src={Armour} alt="" />
              <p>Quality Assured</p>
            </div>
            <div className="flex items-center gap-2">
              <img src={Pipette} alt="" />
              <p>Fast Results</p>
            </div>
          </div>
        </div>
        <div
          data-aos="fade-up"
          data-aos-delay="0"
          data-aos-duration="1000"
          className="md:w-[50%] lg:w-[40%]"
        >
          <img src={Nurse} alt="" />
        </div>
      </section>

      <div className="lg:px-24 md:px-10 px-4 py-10 flex items-center gap-5 md:flex-row flex-col justify-center">
        <img src={Doctor} alt="" />
        <img src={Nurses} alt="" />
        <img src={Award} alt="" />
      </div>

      <section className="lg:px-24 md:px-10 px-4 py-16 bg-lightGrey">
        <h1 className="md:text-3xl text-center w-[70%] mx-auto text-2xl font-bold text-primaryPurple">
          Our Diagnostic Services
        </h1>

        <div className="grid grid-flow-row place-items-center lg:grid-cols-3 md:grid-cols-2 grid-cols-1 justify-center py-5 gap-4 ">
          {services?.map((item) => (
            <div
              data-aos="fade-up"
              data-aos-delay="0"
              data-aos-duration="1000"
              key={item?.id}
              className="bg-white rounded-lg w-[20rem] md:w-[22rem] h-[14rem] p-4 px-6"
            >
              <h1 className="text-lg font-bold text-primaryPurple">
                {item?.service}
              </h1>

              <div className="flex items-center justify-between py-2">
                <p className="text-gray-600">{item?.prop1}</p>
                {/* <p className="text-yellow font-semibold">$25</p> */}
              </div>
              <div className="flex items-center justify-between pb-2 ">
                <p className="text-gray-600">{item?.prop2}</p>
                {/* <p className="text-yellow font-semibold">$25</p> */}
              </div>
              <div className="flex items-center justify-between pb-2 ">
                <p className="text-gray-600">{item?.prop3}</p>
                {/* <p className="text-yellow font-semibold">$25</p> */}
              </div>
              <div className="flex items-center justify-between pb-2 ">
                <p className="text-gray-600">{item?.prop4}</p>
                {/* <p className="text-yellow font-semibold">$25</p> */}
              </div>
            </div>
          ))}
        </div>
      </section>
      {/* <Consult /> */}
      {/* <Testimonials /> */}

      <section
        data-aos="fade-up"
        data-aos-delay="0"
        data-aos-duration="1000"
        className="lg:px-24 md:px-10 px-4 pt-16 pb-8"
      >
        <h1 className="md:text-xl  w-[70%] py-8 text-xl font-bold text-primaryPurple">
          Contact Us
        </h1>

        <p className="font-bold pb-4">Get In Touch</p>

        <div className="flex flex-col gap-3">
          <div className="flex items-center gap-2">
            <FaLocationDot className="text-yellow text-2xl" />
            <p>
              Shopping Complex, Opp Peculiar Grace, Supermarket, Olorunsogo
              Road., Ilorin, Kwara State
            </p>
          </div>
          <div className="flex items-center gap-2">
            <FaPhone className="text-yellow text-2xl" />
            <p>09165311972, 09157776753</p>
          </div>
          <div className="flex items-center gap-2">
            <MdEmail className="text-yellow text-2xl" />
            <p>clearicondiagnostics@gmail.com</p>
          </div>
        </div>

        <p className="font-bold py-4">Opening Hours</p>

        <div className="flex flex-col gap-3">
          <p>Monday - Friday: 8:00 AM - 6:00 PM</p>

          <p>Saturday: 9:00 AM - 6:00 PM</p>

          <p>Sunday: Olorunsogo Branch</p>
        </div>
      </section>

      <div className="relative lg:px-24 md:px-10 mx-4 md:mx-0 py-7">
        <a href="https://wa.link/qsabnq">
          <div className="bg-[#25D366] text-white px-7 py-3 rounded-[25px] flex items-center gap-3 w-[13rem] absolute top-0 right-0">
            <img src={Whatsapp} className="w-[1.2rem]" alt="" />
            <p>Send a message</p>
          </div>
        </a>
      </div>
    </div>
  );
};

export default Home;
